import { __rest } from "tslib";
import * as React from 'react';
import { createCartContext } from './utils';
import { CartService } from './types';
import { useTheme } from '../theme';
import Toolbar from './Toolbar/Toolbar';
import CartFactory from './Fields/CartFactory';
import { useConfig } from '../context';
export const CartContext = React.createContext({
    travellersById: null,
    segmentsById: null,
    totalPrices: {}
});
const CART_SERVICES = [
    CartService.Flights,
    CartService.Seats,
    CartService.Baggage,
    CartService.Meal,
    CartService.Passengers,
    CartService.Extra,
    CartService.Misc
];
const Cart = (_a) => {
    var { prices, cartServices = CART_SERVICES, hideToolbar, onClose, renderServices } = _a, props = __rest(_a, ["prices", "cartServices", "hideToolbar", "onClose", "renderServices"]);
    const { servicesAvailable } = useConfig().global;
    const theme = useTheme('Cart').Cart;
    const includeInsuranceService = cartServices.includes(CartService.Insurances);
    return (React.createElement(CartContext.Provider, { value: createCartContext(props.travellers, props.flight.segments, prices) },
        React.createElement("div", { className: theme.wrapper },
            React.createElement("div", { className: theme.cart },
                cartServices.map(type => (React.createElement(CartFactory, Object.assign({}, props, { key: type, type: type, separateInsurance: includeInsuranceService, separateAnimals: servicesAvailable.animal })))), renderServices === null || renderServices === void 0 ? void 0 :
                renderServices()),
            !hideToolbar && (React.createElement("div", { className: theme.toolbar },
                React.createElement(Toolbar, { onClick: onClose }))))));
};
export default Cart;
